module.exports = __webpack_public_path__ + "static/media/hive.79c93014.png";